<template>
  <div>
    <stage-modal :order="order" @stage-order="stage"></stage-modal>
    <div class="btn-group" v-if="!updating">

      <button :disabled="updating" class="btn btn-sm btn-outline-dark" @click="approve" v-if="order.status.id == 2">
        <i class="fa fa-check"></i> Approve this order
      </button>

      <button :disabled="updating" class="btn btn-sm btn-outline-dark" @click="showStageModal" v-if="order.status.id == 3">
        <i class="fa fa-clipboard-list"></i> Pick Complete / Stage this order
      </button>

      <button :disabled="updating" class="btn btn-sm btn-outline-dark" @click="holdingArea" v-if="order.status.id == 7">
        <i class="fa fa-clipboard-list"></i> Packed / Put in Holding Area
      </button>

      <button :disabled="updating" class="btn btn-sm btn-outline-dark" @click="ship" v-if="order.status.id == 9">
        <i class="fa fa-clipboard-list"></i> Ship this order
      </button>

      <button :disabled="updating" class="btn btn-sm btn-outline-dark" @click="deliver" v-if="order.status.id == 10">
        <i class="fa fa-clipboard-list"></i> Order was delivered
      </button>

      <print-dropdown :order="order"></print-dropdown>
    </div>
    <div v-else>
      <i class="fa fa-spinner fa-spin"></i> Updating
    </div>
  </div>
</template>

<script>

import n from '@/libs/notifications'
import store from '@/stores/outbound'
import outboundOrder from '@/libs/outbound-order'

import StageModal from '@/components/outbound/StageModal'
import PrintDropdown from '@/components/outbound/PrintDropdown'

import $ from 'jquery'

export default {
  name: 'action-buttons',

  components: {
    PrintDropdown,
    StageModal,
  },

  data() {
    return {
      updating: false,
    }
  },

  props: {
    order: Object,
  },

  methods: {
    navigateToStatus() {
      const status = this.$route.params.status
      this.$router.push({ name: 'outbound', params: { status }})
    },

    approve() {
      this.updating = true
      outboundOrder.approve(this.order).then(res => {
        store.updateOrder(res.data.order)
        this.navigateToStatus()
        n.success("Order is now approved.")
      }).catch(err => {
        n.error(err)
      }).finally(() => this.updating = false)
    },

    stage(picked) {
      this.updating = true
      outboundOrder.stage(this.order, picked).then(res => {
        store.updateOrder(res.data.order)
        this.navigateToStatus()
        this.hideStageModal()
        n.success("Order is now staged.")
      }).catch(err => {
        n.error(err)
      }).finally(() => this.updating = false)
    },

    holdingArea() {
      this.updating = true
      outboundOrder.holdingArea(this.order).then(res => {
        store.updateOrder(res.data.order)
        this.navigateToStatus()
        this.hideStageModal()
        n.success("Order is now packed and in holding area.")
      }).catch(err => {
        n.error(err)
      }).finally(() => this.updating = false)
    },

    ship() {
      this.updating = true
      outboundOrder.ship(this.order).then(res => {
        store.updateOrder(res.data.order)
        this.navigateToStatus()
        n.success("Order is now shipped.")
      }).catch(err => {
        n.error(err)
      }).finally(() => this.updating = false)
    },

    deliver() {
      this.updating = true
      outboundOrder.deliver(this.order).then(res => {
        store.updateOrder(res.data.order)
        this.navigateToStatus()
        n.success("Order is now delivered.")
      }).catch(err => {
        n.error(err)
      }).finally(() => this.updating = false)
    },

    showStageModal() { $('#stageModal').modal('show') },
    hideStageModal() { $('#stageModal').modal('hide') },
  }
}
</script>
